// File: @/app/global-error.tsx

'use client';

import '@/styles/globals.css';

import { type JSX, useEffect } from 'react';

import { StatusMessage } from '@/components/content/status-message';
import { logger } from '@/lib/logger';

interface GlobalErrorProps {
  readonly error: Error & { readonly digest?: string };
}

/**
 * Last-resort boundary for errors thrown by the root layout itself, which
 * app/error.tsx cannot catch. It replaces the whole document, so it renders
 * its own <html> and <body> and deliberately avoids layout-level
 * dependencies (fonts, analytics) that may be what failed.
 */
export default function GlobalError({ error }: GlobalErrorProps): JSX.Element {
  useEffect(() => {
    logger.error('[Global Error] Root layout error', error, { digest: error.digest });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <StatusMessage
          message="Sorry — this page didn’t load properly. Please try again in a moment."
          title="Something went wrong"
        />
      </body>
    </html>
  );
}
